<template lang="html">
  <div style="height: 100vh" class="flex-column-container">
    <navbar style="height: 50px" />
    <div class="h-100 flex-column-container">
      <online-roundtable-index class="h-100" />
    </div>
    <pl-dialog
      v-if="welcome_modal"
      @close="welcome_modal = false"
      height="auto"
      maxHeight="400px"
      minWidth="600px"
      padding="2em"
      :disableOutsideClick="true"
    >
      <div class="ph3 flex-column-container" style="height: 100%">
        <div style="width: 50px; margin: 20px auto">
          <img src="/static/logos/parlay_logo.svg" alt="parlay_logo" />
        </div>
        <div class="tc pl-subheading mb3">
          <strong>
            Welcome to Parlay's Online RoundTable Interactive Demo!
          </strong>
        </div>
        <div class="flex-grow" style="margin: auto">
          <div
            class="pl-subheading ph4 pv3 tc w-70 br3 shadow-1"
            style="margin: auto"
          >
            <!-- <div class="flex items-center"> -->
            <div class="interactive-demo-dot center mb2"></div>
            <div class="w-auto pl-body-1">
              Click on the pink information buttons to learn about a feature
            </div>
            <!-- </div> -->
          </div>
        </div>
        <div class="flex mt3 center">
          <pl-button @click.native="welcome_modal = false" class="pl-primary">
            Got it!
          </pl-button>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>

<script>
  import OnlineRoundtableIndex from 'features/onlineRoundtables/rtIndex.vue';
  import Navbar from './onlineWalkthrough.navbar.vue';

  export default {
    data() {
      return {
        welcome_modal: true,
      };
    },
    components: {
      OnlineRoundtableIndex,
      Navbar,
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// onlineWalkthrough.index.vue?b6c3a814